module.exports = __webpack_public_path__ + "img/bg-1.dc400744.jpg";